import "../../styles/Pages/Conformaliter/PolitiqueConfidentialite.css";

export default function PolitiqueConfidentialite() {
  return (
    <div className="privacy-page">
      <header className="privacy-hero">
        <h1>Politique de confidentialité</h1>
        <p className="privacy-update">En vigueur au {new Date().toLocaleDateString()}</p>
      </header>

      {/* Sommaire */}
      <nav className="privacy-toc" aria-label="Sommaire">
        <ul>
          <li><a href="#scope">1. Objet et champ d’application</a></li>
          <li><a href="#data">2. Données que nous collectons</a></li>
          <li><a href="#purposes">3. Finalités & bases légales</a></li>
          <li><a href="#responsable">4. Responsable du traitement</a></li>
          <li><a href="#cookies">5. Cookies & traceurs</a></li>
          <li><a href="#third">6. Destinataires & sous-traitants</a></li>
          <li><a href="#retention">7. Durées de conservation</a></li>
          <li><a href="#rights">8. Vos droits (RGPD)</a></li>
          <li><a href="#security">9. Sécurité</a></li>
          <li><a href="#nosell">10. Ne pas vendre ou partager mes données</a></li>
          <li><a href="#transfer">11. Transferts hors UE</a></li>
          <li><a href="#contact">12. Contact</a></li>
          <li><a href="#changes">13. Mises à jour</a></li>
        </ul>
      </nav>

      <main className="privacy-content">
        <section id="scope" className="privacy-block">
          <h2>1. Objet et champ d’application</h2>
          <p>
            La présente politique explique comment <strong>VERTYNO</strong> collecte, utilise et protège vos
            données personnelles lors de votre navigation sur <strong>https://vertyno.fr/</strong>, de vos
            achats (sur notre site et/ou plateformes partenaires), et de vos interactions (formulaire de
            contact, newsletter, réseaux sociaux).
          </p>
        </section>

        <section id="data" className="privacy-block">
          <h2>2. Données que nous collectons</h2>
          <ul className="privacy-list">
            <li><strong>Données d’identification :</strong> nom, prénom, email, éventuellement adresse postale et téléphone.</li>
            <li><strong>Données de commande :</strong> produits achetés, adresse de livraison/facturation, historique.</li>
            <li><strong>Données de paiement :</strong> traitées de façon sécurisée par nos prestataires (nous n’y avons pas accès en clair).</li>
            <li><strong>Données techniques :</strong> logs, adresse IP, navigateur, pages consultées (via cookies/analytics).</li>
            <li><strong>Newsletter :</strong> adresse email et préférences éventuelles.</li>
          </ul>
        </section>

        <section id="purposes" className="privacy-block">
          <h2>3. Finalités & bases légales</h2>
          <ul className="privacy-list">
            <li><strong>Traitement des commandes</strong> (exécution du contrat) : achat, livraison, service client.</li>
            <li><strong>Newsletter & offres</strong> (consentement) : envoi après votre inscription volontaire.</li>
            <li><strong>Contact/Support</strong> (intérêt légitime / mesures précontractuelles) : répondre à vos demandes.</li>
            <li><strong>Amélioration du site & statistiques</strong> (intérêt légitime / consentement cookies).</li>
            <li><strong>Obligations légales</strong> : comptabilité, lutte contre la fraude, garanties.</li>
          </ul>
        </section>

        <section id="responsable" className="privacy-block">
          <h2>4. Responsable du traitement</h2>
          <p>
            Le responsable du traitement des données personnelles est :
          </p>
          <p>
            <strong>VERTYNO – SASU</strong><br />
            9 Allée Gabriel Zirnhelt, 93110 Rosny-sous-Bois, France<br />
            📧 <a className="privacy-link" href="mailto:contact@vertyno.com">contact@vertyno.com</a><br />
            📞 +33 6 61 05 05 71
          </p>
        </section>

        <section id="cookies" className="privacy-block">
          <h2>5. Cookies & traceurs</h2>
          <p>
            Nous utilisons des cookies nécessaires au fonctionnement du site et, sous réserve de votre
            consentement, des cookies de mesure d’audience et/ou marketing. Vous pouvez à tout moment
            paramétrer votre navigateur pour accepter, refuser ou supprimer les cookies.
          </p>
        </section>

        <section id="third" className="privacy-block">
          <h2>6. Destinataires & sous-traitants</h2>
          <p>
            Vos données peuvent être traitées par des prestataires de confiance (hébergeur, solution
            emailing/newsletter, paiement, logistique) strictement pour les finalités décrites et dans le respect
            du RGPD. Nous ne vendons pas vos données.
          </p>
        </section>

        <section id="retention" className="privacy-block">
          <h2>7. Durées de conservation</h2>
          <ul className="privacy-list">
            <li><strong>Compte & commandes :</strong> durée de la relation, puis archives légales (généralement 5 à 10 ans selon obligation).</li>
            <li><strong>Newsletter :</strong> jusqu’au désabonnement ou 3 ans après le dernier contact.</li>
            <li><strong>Logs & analytics :</strong> durée proportionnée (souvent 13 mois pour les cookies de mesure d’audience).</li>
            <li><strong>Support :</strong> le temps de traiter la demande puis une durée limitée d’archive.</li>
          </ul>
        </section>

        <section id="rights" className="privacy-block">
          <h2>8. Vos droits (RGPD)</h2>
          <p>
            Vous disposez des droits d’<strong>accès</strong>, <strong>rectification</strong>, <strong>effacement</strong>, de
            <strong> limitation</strong>, d’<strong>opposition</strong>, et du droit à la <strong>portabilité</strong> de vos données.
            Vous pouvez aussi définir des directives post-mortem. Pour exercer vos droits :
          </p>
          <p className="privacy-contact-inline">
            Email : <a className="privacy-link" href="mailto:contact@vertyno.com">contact@vertyno.com</a> ou{" "}
            <a className="privacy-link" href="mailto:mickaelouis03@gmail.com">mickaelouis03@gmail.com</a>
          </p>
          <p>
            Vous avez le droit d’introduire une réclamation auprès de la <strong>CNIL</strong> si vous estimez que vos
            droits ne sont pas respectés.
          </p>
        </section>

        <section id="security" className="privacy-block">
          <h2>9. Sécurité</h2>
          <p>
            Nous mettons en œuvre des mesures techniques et organisationnelles adaptées pour protéger vos
            données (contrôles d’accès, chiffrement côté prestataires de paiement, sauvegardes, etc.).
          </p>
        </section>

        <section id="nosell" className="privacy-block">
          <h2>10. Ne pas vendre ou partager mes données</h2>
          <p>
            Chez <strong>VERTYNO</strong>, la protection de vos données personnelles est une priorité. Nous nous engageons
            à <strong>ne jamais vendre vos données personnelles</strong> à des tiers.
          </p>
          <p>
            Cela inclut notamment :
          </p>
          <ul className="privacy-list">
            <li>votre nom et prénom,</li>
            <li>votre adresse postale,</li>
            <li>votre adresse e-mail,</li>
            <li>votre numéro de téléphone,</li>
            <li>toute information fournie lors de l'utilisation du site ou d'une commande.</li>
          </ul>
          <p><strong>Aucune donnée personnelle n'est cédée à des fins commerciales.</strong></p>

          <h3>Partage strictement encadré des données</h3>
          <p>
            VERTYNO ne partage vos données personnelles que dans les cas strictement nécessaires suivants :
          </p>
          <p><strong>a) Prestataires techniques et opérationnels</strong></p>
          <p>
            Certaines données peuvent être transmises à des prestataires agissant exclusivement pour le compte de VERTYNO,
            tels que :
          </p>
          <ul className="privacy-list">
            <li>prestataires de paiement (ex. Stripe, PayPal, Apple Pay, Klarna),</li>
            <li>transporteurs et services de livraison,</li>
            <li>prestataires techniques (hébergement, plateforme e-commerce, support).</li>
          </ul>
          <p>Ces prestataires sont contractuellement tenus :</p>
          <ul className="privacy-list">
            <li>de respecter la confidentialité des données,</li>
            <li>de n'utiliser les données que pour la mission confiée,</li>
            <li>de se conformer au RGPD.</li>
          </ul>

          <p><strong>b) Obligations légales</strong></p>
          <p>Vos données peuvent être communiquées si la loi l'exige, notamment dans le cadre :</p>
          <ul className="privacy-list">
            <li>d'une obligation légale ou réglementaire,</li>
            <li>d'une décision judiciaire,</li>
            <li>de la protection des droits, de la sécurité ou de la prévention de la fraude.</li>
          </ul>
        </section>

        <section id="transfer" className="privacy-block">
          <h2>11. Transferts hors Union européenne</h2>
          <p>
            Si certains prestataires traitent des données en dehors de l’UE, ces transferts sont encadrés par
            des mécanismes légaux adéquats (clauses contractuelles types, décision d’adéquation, etc.).
          </p>
        </section>

        <section id="contact" className="privacy-block">
          <h2>12. Contact</h2>
          <p>
            Pour toute question relative à cette politique ou à vos données :{" "}
            <a className="privacy-link" href="mailto:contact@vertyno.com">contact@vertyno.com</a>.
          </p>
        </section>

        <section id="changes" className="privacy-block">
          <h2>13. Mises à jour</h2>
          <p>
            La présente politique peut évoluer. Toute modification substantielle sera signalée sur cette page
            et, le cas échéant, par email si vous êtes inscrit à la newsletter.
          </p>
        </section>
      </main>
    </div>
  );
}
